import { styled } from "@mui/material/styles";
import ListItemIcon from "@mui/material/ListItemIcon";

export const MenuItemIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: "24px",
  marginRight: "8px",
  color: theme.palette.textMain.main3,
}));
